/**
 * TidePrediction Component
 *
 * Simple component to display tide prediction data with highest/lowest tide times in EST
 * and an interactive chart showing tide predictions over time.
 *
 * @component
 * @param {Object} tideData - The tide prediction data from the API
 * @param {boolean} loading - Loading state
 * @param {string} error - Error message if any
 * @returns {JSX.Element} The rendered TidePrediction component
 */

import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Skeleton,
  Alert,
  CircularProgress,
} from "@mui/material";
import TideChart from "./TideChart";

//passing padding to the component because the weather dashboard has a padding of 2 and kiosk mode has a padding of 0 ,both are using this component
const TidePrediction = ({ tideData, loading, error,padding=2 }) => {
  if (error) {
    return null;
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!tideData) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", p: padding }}>
      {/* Interactive Chart */}
      <TideChart tideData={tideData} loading={loading} error={error} />
    </Box>
  );
};

export default TidePrediction;
